module.exports = __webpack_public_path__ + "static/img/2_1_3_3.e3255077.jpg";